export enum EQueryKeys {
  AccountQueryKeys = 'AccountQueryKeys',
  AssetQueryKeys = 'AssetQueryKeys',
  BranchQueryKeys = 'BranchQueryKeys',
  CounterpartyQueryKeys = 'CounterpartyQueryKeys',
  CustomerQueryKeys = 'CustomerQueryKeys',
  EmployeesQueryKeys = 'EmployeesQueryKeys',
  LimitsQueryKeys = 'LimitsQueryKeys',
  ReconciliationQueryKeys = 'ReconciliationQueryKeys',
  ReportingPaymentsQueryKeys = 'ReportingPaymentsQueryKeys',
  SegmentsQueryKeys = 'SegmentsQueryKeys',
  RbacQueryKeys = 'RbacQueryKeys',
  EmissionQueryKeys = 'EmissionQueryKeys',
  MerchantQueryKeys = 'MerchantQueryKeys',
  PermissionQueryKeys = 'PermissionQueryKeys',
  AuditQueryKeys = 'AuditQueryKeys',
}
